import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../Actions/bankfeeds';
import { Button, Checkbox } from '@material-ui/core';
import Select from 'react-select';
import Spinner from '../UI/Spinner/spinner';

import css from './bfm.css';

const historyOptions = [{ value: 0, label: '0' }, { value: 1, label: '1' }, { value: 2, label: '2' }, { value: 3, label: '3' }, { value: 4, label: '4' }, { value: 5, label: '5' }, { value: 6, label: '6' }, { value: 7, label: '7' }, { value: 8, label: '8' }, { value: 9, label: '9' }, { value: 10, label: '10' }, { value: 11, label: '11' }, { value: 12, label: '12' } ];

class BnzSelectAccount extends Component {

    state = { accounts: [], history: 0, creating: false };

    componentDidMount() {
       this.props.getBnzAccountList(this.props.match.params.token);
     }

     handleCheckboxClicked = (value) => {
         const accounts = (this.state.accounts.includes(value)) ? this.state.accounts.filter(id => id !== value) : [...this.state.accounts, value];
         this.setState({ accounts });
     }

     handleCreateFeeds = () => {
        const { token, userId, bookId } = this.props.match.params;
        const data = { accounts: this.state.accounts, history: this.state.history, token, userId, bookId };
        this.props.addBnzFeeds(
            data,
            (creating) => this.setState({ creating }),
            () => this.props.history.push('/bfm'));
    }

     renderAccounts = (accounts) => {
        return accounts.map(account => {
        return (
            <div className={[css.dFlex, css.alignCenter, css.feedRow].join(' ')}>
               <div><Checkbox id={account.id} onChange={() => this.handleCheckboxClicked(account.id)} /></div>
               <div className={css.w300}>{account.nickname}</div>
               <div className={css.w215}>{account.productDescription}</div>
               <div className={css.w215}>{account.accountNumberFormatted}</div> 
            </div>
        );
        })
     }

     render() {
        if (!this.props.bankAccounts) {
            return (
                <div className={css.container}>
                    <div className={css.card}>
                        <div className={[css.cardHeading, css.pb20].join(' ')}>BNZ Bank Accounts</div>
                        <Spinner small  />
                    </div>
                </div>
            );
        }

        return (
            <div className={css.container}>
                <div className={css.card}>
                   <div className={[css.cardHeading, css.pb20].join(' ')}>BNZ Bank Accounts</div>
                    <div className={css.pb20}>{this.renderAccounts(this.props.bankAccounts)}</div>
                    <div className={[css.dFlex, css.contentBetween, css.alignCenter, css.pb20, css.historyOption].join(' ')}>
                        <div>Download transaction history (months): </div>
                        <Select className={css.w120} isClearable options={historyOptions} labelKey="value" onChange={(value) => this.setState({ history: value.value })}/>
                    </div>
                    <Button variant="contained" color="primary" disabled={this.state.creating} fullWidth onClick={this.handleCreateFeeds}>{this.state.creating ? 'Creating feeds' : 'Create feeds for selected accounts'}</Button>
                </div>
            </div>
        );
     }

    }

function mapStateToProps({ bankfeeds }) {
    return { bankAccounts: bankfeeds.bankfeeds }
}
      
export default connect(mapStateToProps, actions)(BnzSelectAccount);
    


// WEBPACK FOOTER //
// ./src/components/FeedManagment/BnzSelectAccounts.js